<template>
    <div style="height: 100%;" class="ku_bg">
        <el-container class="home-c" style="height: 100%;">
            <el-aside width="auto">
                <div
                    style="display: flex;justify-content: center;align-items: center;margin-top: 20px;margin-bottom: 10px;">

                    <el-input placeholder="搜索名称" v-model="filterText" size="small" style="width:55%;">
                        <i class="el-icon-search" slot="suffix"
                            style="padding-right:6px;padding-top: 8px;font-size: 17px;color: #999;font-weight: 600;"></i>
                    </el-input>
                    <el-button icon="el-icon-folder-add" plain
                        style="font-size: 20px;width:30px;height: 30px;padding: 0;margin-left: 10px;"
                        @click="cjwj = true"></el-button>
                    <div style="font-size: 12px;margin-left: 5px;">{{ ku_files.length }}/{{ xm }}</div>
                </div>

                <div>
                    <el-menu :default-active="name_key" class="el-menu-vertical-demo sidear_container"
                        background-color="#fff" text-color="#333" active-text-color="#d4e7ff">

                        <div>
                            <el-tree :data="ku_files" :props="props" :load="loadNode" lazy :highlight-current="true"
                                :filter-node-method="filterNode" ref="trees" @node-click="treeclick" node-key="id"
                                :default-expanded-keys="defaultExpandIds" :default-checked-keys="defaultExpandIds">
                                <span slot-scope="{ node, data }"
                                    style="font-weight: 600;font-size: 14px;width: 100%;height: 100%;display: flex;align-items: center;justify-content: space-between;"
                                    class="show-hide">

                                    <div>
                                        <i class="el-icon-folder-checked" style="font-weight: 600;color: green;"
                                            v-if="node.data.share == 1"></i>
                                        <i class="el-icon-folder" style="font-weight: 600;" v-else></i>

                                        <span style="padding-left: 4px;">{{ node.data.name }}</span>

                                        <el-tag size="mini" type="info" v-if="node.data.num">{{ node.data.num }}
                                        </el-tag>
                                        <!-- <span style="padding-left: 4px;font-size: 12px;font-weight: 500;" v-if="node.data.num">{{node.data.num}}</span> -->
                                    </div>
                                    <div style="margin-right: 10px;" class="tree_other">
                                        <span v-if="node.data.parent == 0">
                                            <el-button class="tree_button" slot="suffix" type="text" icon="el-icon-share"
                                                @click.stop="tree_share(node)">
                                            </el-button>

                                            <el-button class="tree_button" slot="suffix" type="text" icon="el-icon-refresh"
                                                @click.stop="tree_refresh(node)">
                                            </el-button>

                                            <el-button class="tree_button" slot="suffix" type="text" icon="el-icon-edit"
                                                @click.stop="tree_edit(node)"></el-button>

                                            <el-button class="tree_button" slot="suffix" type="text" icon="el-icon-delete"
                                                @click.stop="tree_del(node)"></el-button>
                                        </span>
                                    </div>

                                </span>

                            </el-tree>
                        </div>


                    </el-menu>

                </div>
            </el-aside>

            <el-container>
                <el-header>
                    <div
                        style="display: flex; align-items: center;justify-content: space-between;border-bottom: 1px solid #f1f1f1;">
                        <div
                            style="display: flex;align-items: center;height: 60px;font-size: 22px;font-weight: 500;margin-left: 20px;">
                            {{ name_key }}
                        </div>
                        <!-- <div style="margin-right: 20px;">
                            <el-button icon="el-icon-arrow-left" size="medium" style="height: 35px;" type="primary"
                                plain @click="jindu = true">查看进度
                            </el-button>
                        </div> -->
                        <!-- <div style="margin-right: 20px;">
                            <el-tag effect="plain" v-if="chuli_pd.zt == 1">
                                仓库制作中: 您在第{{ chuli_pd.wz }}位 | 官网有{{ chuli_pd.zs }}个任务
                            </el-tag>
                            <el-tag type="info" effect="plain" v-else>
                                仓库制作: 官网有{{ chuli_pd.zs }}个任务在制作
                            </el-tag>

                            <el-tag type="success" effect="plain" v-if="make_pd.zt == 1">
                                视频制作中: 您在第{{ make_pd.wz }}位 | 官网有{{ make_pd.zs }}个任务
                            </el-tag>
                            <el-tag type="info" effect="plain" v-else>
                                视频制作: 官网有{{ make_pd.zs }}个任务在制作
                            </el-tag>
                        </div> -->

                    </div>

                </el-header>
                <el-main>
                    <div v-if="name_key">
                        <div style="display: flex;justify-content: space-between;align-items: center;margin-bottom: 10px;">
                            <div style="display: flex;align-items: center;">
                                <el-input placeholder="搜索文件名" v-model="search" size="small" style="width:200px;">
                                    <!-- <el-button style="padding-right:6px;padding-top: 7px;font-size: 18px;" slot="suffix" type="text" icon="el-icon-search"></el-button> -->
                                    <i class="el-icon-search" slot="suffix"
                                        style="padding-right:6px;padding-top: 8px;font-size: 17px;color: #999;font-weight: 600;"></i>
                                </el-input>
                                <div style="font-size: 13px;color: #666;margin-left: 5px;">制作点数:{{ surplus }}</div>
                                <!-- <el-button icon="el-icon-refresh" plain
                                    style="font-size: 20px;width:30px;height: 30px;padding: 0;margin-left: 10px;"
                                    @click="tree_get_file(page,1)"></el-button> -->
                            </div>


                            <div>
                                <el-button icon="el-icon-picture-outline-round" plain style="font-size: 13px;" size="small"
                                    type="warning"
                                    @click="share_cover = []; imgs_list(); share_cover_show = true">图文素材</el-button>
                                <el-button icon="el-icon-edit" plain style="font-size: 13px;" size="small" type="warning"
                                    @click="edit_title_fc">编辑文案</el-button>
                                <el-button icon="el-icon-share" plain style="font-size: 13px;" size="small" type="danger"
                                    @click="">分享仓库</el-button>

                                <el-button icon="el-icon-scissors" plain style="font-size: 13px;" size="small"
                                    type="success" @click="make_video_fc">制作视频</el-button>
                                <!-- <el-button icon="el-icon-arrow-left" plain style="font-size: 13px;" size="small"
                                    type="primary" @click="jindu = true">查看进度</el-button> -->
                            </div>

                        </div>
                        <div>
                            <el-row :gutter="20">
                                <el-col :xs="6" :sm="6" :xl="4" style="padding: 15px 15px 0px 15px;">
                                    <el-card class="box-card" shadow="never"
                                        style="border-radius:10px;height:250px;display: flex;justify-content: center;align-items: center;">


                                        <div style="text-align: center;margin-bottom: 20px;" v-if="spk_select.parent == 0">
                                            <el-button type="success" icon="el-icon-paperclip" size="medium"
                                                style="height: 35px;font-size: 13px;padding: ;" @click="ku_add = true">
                                                上传链接添加
                                            </el-button>
                                        </div>

                                        <div style="text-align: center;">
                                            <el-button type="primary" icon="el-icon-circle-plus-outline" size="medium"
                                                style="height: 35px;font-size: 13px;" @click="upload_video = true">
                                                上传视频添加
                                            </el-button>
                                        </div>

                                        <div v-if="spk_select.parent == 0"
                                            style="font-size: 12px;color: #777;margin-top: 23px;">*此页面上传将为您自动分割视频为片段
                                        </div>
                                    </el-card>
                                </el-col>
                                <div v-for="(item, i) in spk_files" :key="i">
                                    <el-col :xs="6" :sm="6" :xl="4" style="padding: 15px 15px 0px 15px;">
                                        <div class="videotp">

                                            <el-image style="width: 100%; height: 100%;border-radius: 10px;"
                                                fit="scale-down" :src="item.image" v-if="item.type == 0">
                                            </el-image>
                                            <el-image style="width: 100%; height: 100%;border-radius: 10px;"
                                                :src="require('@/assets/img/music_file.png')" fit="contain" v-else>
                                            </el-image>

                                            <div style="position:absolute;z-index: 99;top:0;right: 0;left: 0;bottom: 0;display: flex;align-items: center;justify-content: center;background-color: rgb(99,99,99,0.1);border-radius: 10px;"
                                                @click="lookvideo_fc(item)">

                                                <i class="el-icon-video-play" slot="suffix"
                                                    style="font-size: 45px;color: #fff;"></i>
                                            </div>

                                            <div
                                                style="position:absolute;z-index: 99;top:0;right: 0;display: flex;justify-content: end;border-radius: 10px;">
                                                <i class="el-icon-close" slot="suffix"
                                                    style="font-size: 14px;color: rgb(108 108 108);padding: 4px;background-color: #fff;margin: 3px;font-weight: 600;border-radius: 12px;"
                                                    @click="del_video(item)"></i>

                                            </div>
                                            <div
                                                style="position:absolute;z-index: 99;top:4px;left: 2px;display: flex;justify-content: end;border-radius: 10px;">
                                                <el-checkbox v-model="check_video" :label="item.id"
                                                    @change="checked => check_video_fc(checked, item.id)"></el-checkbox>

                                            </div>
                                            <!-- <div
                                                style="position:absolute;z-index: 99;top:0;right:0;display: flex;justify-content: end;border-radius: 10px;" >
                                                <i class="el-icon-delete" slot="suffix"
                                                    style="font-size: 13px;color: #fff;padding: 5px 8px;background-color: rgb(229 84 69);font-weight: 600;border-radius: 0px 10px 0px 10px;"
                                                    @click="del_video(item)"></i>
                                            </div> -->
                                            <div
                                                style="position:absolute;z-index: 99;right: 0;bottom: 0;display: flex;justify-content: end;border-radius: 10px;">
                                                <i class="el-icon-download" slot="suffix"
                                                    style="font-size: 13px;color: #fff;padding: 5px 8px;background-color: rgb(100 202 10);font-weight: 600;border-radius: 11px 0px 10px 0px;"
                                                    @click="down_video(item)"></i>
                                            </div>
                                        </div>
                                        <div style="text-align: center;background-color: rgb(255,255,255,0.8);margin: 0;">
                                            <div
                                                style="text-align: center;font-size: 12px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                                {{ item.name }}
                                            </div>
                                        </div>

                                    </el-col>
                                </div>
                            </el-row>
                        </div>
                    </div>
                    <div v-else>
                        <el-empty :image-size="200">
                            <el-button type="primary" style="font-size: 18px;" @click="cjwj = true">立即创建您的视频项目
                            </el-button>
                        </el-empty>

                    </div>

                </el-main>
                <el-footer style="border-top: 1px solid #f5f5f5;">
                    <div style="margin-top: 10px;">
                        <el-pagination background layout="total,prev, pager, next" :page-size="11" :total="total"
                            @current-change="fy_page" :current-page="page">
                        </el-pagination>
                    </div>
                </el-footer>
            </el-container>
        </el-container>


        <el-dialog title="新建项目" :visible.sync="cjwj" width="40%">

            <el-form :model="cjwj_from" ref="cjwj_from" label-width="100px" class="demo-ruleForm" :rules="rules">
                <el-form-item label="项目名称" prop="wjname">
                    <el-input v-model.number="cjwj_from.wjname" autocomplete="off" size='small' maxlength="12"
                        show-word-limit style="width: 90%;"></el-input>
                </el-form-item>
                <el-form-item style="margin-top: 30px;">
                    <el-button type="primary" @click="cjwj_fc('cjwj_from')" size="medium">创建</el-button>
                    <el-button @click="cjwj = false" size="medium">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="分享项目" :visible.sync="share_show" width="500px">
            <div>
                <el-switch inactive-text="开启分享" v-model="share_item.share" @change="share_open">
                </el-switch>
            </div>
            <div v-if="share_cover.length != 0">
                <div style="margin-top: 30px;display: flex;">
                    <div>当前封面</div>
                    <div style="margin-left: 10px;">
                        <div v-if="share_item.cover" style="display: flex;align-items: flex-end;">
                            <el-image style="width: 60px; height: 100px;border-radius: 5px;" fit="cover"
                                :src="share_item.cover">
                            </el-image>
                            <div style="margin-left: 5px;cursor: pointer;" @click="share_cover_show = true">修改</div>
                        </div>

                        <el-button size="mini" type="primary" @click="share_cover_show = true" v-else>立即设置</el-button>
                    </div>
                </div>
                <div style="margin-top: 30px;display: flex;align-items: center;">
                    <div>分类设置</div>
                    <el-select v-model="share_item.type" placeholder="请选择" size="small" style="margin-left: 10px;">
                        <el-option v-for="item in ku_type" :key="item.name" :label="item.name" :value="item.name">
                        </el-option>
                    </el-select>
                </div>

                <div style="margin-top: 30px;display: flex;align-items: center;">
                    消耗点数
                    <el-input-number size="mini" v-model="share_item.surplus" style="margin-left: 10px;"></el-input-number>
                </div>
            </div>

            <div style="margin-top: 10px;display: flex;justify-content: end;" v-if="share_cover.length != 0">
                <el-button type="primary" @click="share_set">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog width="650px" :title="is_imgs == 1 ? '图文素材' : '设置封面'" :visible.sync="share_cover_show">
            <div style="margin-top: 0px;display: flex;flex-wrap: wrap;">
                <div v-for="(item, index) in share_cover" :key="index" style="margin: 10px;" class="show-hide">
                    <div style="width: 130px;position: relative;" @click="share_cover_set(item)">
                        <el-image style="width: 100%;height: 200px;border-radius: 5px;" fit="cover"
                            :src="item.image"></el-image>
                        <div style="position: absolute;bottom: 4px;top: 0;left: 0;right: 0;align-items: center;justify-content: center;background-color: rgba(0, 0, 0, 25%);border-radius: 5px;"
                            class="tree_other">
                            <i class="el-icon-thumb" style="font-size:30px;color: #fff;"></i>
                        </div>
                    </div>
                    <div v-if="is_imgs" style="font-size: 13px;color:#ce0704;cursor: pointer;"
                        @click="del_img(item, index)">
                        删除
                    </div>
                </div>
            </div>
            <div style="margin-top: 10px;">
                <el-pagination background layout="total,prev, pager, next" :page-size="(is_imgs == 1 ? 9 : 8)"
                    :total="share_cover_total" @current-change="fy_share_cover_page" :current-page="share_cover_page">
                </el-pagination>
            </div>
        </el-dialog>
        <el-dialog title="制作视频" :visible.sync="make_video" width="40%">
            <makevideo_view :kuinfo="make_video_info" @make_video_wc="make_video_wc"></makevideo_view>

        </el-dialog>

        <el-dialog title="上传视频" :visible.sync="upload_video" width="40%">
            <upload_view :kuinfo="spk_select" :namekey="name_key"></upload_view>

        </el-dialog>

        <el-dialog title="添加链接" :visible.sync="ku_add" :close-on-click-modal="false" :close-on-press-escape="false"
            :before-close="ku_add_close">
            <div style="margin-bottom: 20px;font-size: 13px;color:#666;">请对 "{{ spk_select.name }}" 项目进行添加设置</div>
            <div style="margin-bottom: 10px;color: #888;font-size: 13px;">
                以链接添加
            </div>
            <el-input type="textarea" v-model="all_url" :rows="6" placeholder="一行一个链接"></el-input>
            <el-link style="font-size: 13px;" type="danger">需要上传视频？点击下载上传工具</el-link>
            <div style="margin: 20px 0px 10px 0px;color: #888;font-size: 13px;">
                其他设置

            </div>
            <div>
                提取视频为音乐
                <el-switch v-model="ku_add_music" active-color="#13ce66">
                </el-switch>
            </div>
            <div style="margin-top: 30px;display: flex;justify-content: end;">
                <el-button type="success" style="width: 100px;" @click="ku_tjlj">添加</el-button>
            </div>
        </el-dialog>
        <el-drawer title="进度" :visible.sync="jindu" direction="rtl">
            <span>我来啦!</span>
        </el-drawer>

        <el-dialog title="编辑文案" :visible.sync="edit_title_show" :close-on-press-escape="false" custom-class="newdialog">
            <div style="">
                <el-button plain style="float: right;margin-top: -10px;" size="mini" type="warning"
                    @click="edit_title_show2 = true; edit_title_item = { 'type': 1, 'kuid': spk_select.id }">+新建标题</el-button>
            </div>
            <div class="biaoqian" style="padding-top: 0;">发布标题</div>

            <div>
                <div v-for="(item, index) in edit_title_list.bt"
                    style="background-color: #f3f3f3;padding: 1vh;font-size: 0.8rem;border-radius: 5px;color: #000;margin-bottom: 10px;display: flex;justify-content: space-between;">
                    <div style="width: 90%;">
                        {{ item.text }}
                    </div>
                    <div style="width: 50px;display: flex;justify-content: center;align-items: center;border-left: 1px solid #d6d6d6;color: #0447ce;margin-left: 5px;cursor: pointer;"
                        @click="edit_title_show2 = true; edit_title_item = item">
                        编辑
                    </div>
                    <div style="width: 50px;display: flex;justify-content: center;align-items: center;border-left: 1px solid #d6d6d6;color: #ce0704;margin-left: 5px;cursor: pointer;"
                        @click="del_title(item, index)">
                        删除
                    </div>
                </div>
            </div>
            <div style="">
                <el-button plain style="float: right;margin-top: -0px;" size="mini" type="warning"
                    @click="edit_title_show2 = true; edit_title_item = { 'type': 2, 'kuid': spk_select.id }">+新建文案</el-button>
            </div>
            <div class="biaoqian">文案脚本</div>
            <div>
                <div v-for="(item, index) in edit_title_list.jb"
                    style="background-color: #f3f3f3;padding: 1vh;font-size: 0.8rem;border-radius: 5px;color: #000;margin-bottom: 10px;display: flex;justify-content: space-between;">
                    <div style="width: 90%;">
                        {{ item.text }}
                    </div>
                    <div style="width: 50px;display: flex;justify-content: center;align-items: center;border-left: 1px solid #d6d6d6;color: #0447ce;margin-left: 5px;cursor: pointer;"
                        @click="edit_title_show2 = true; edit_title_item = item">
                        编辑
                    </div>
                    <div style="width: 50px;display: flex;justify-content: center;align-items: center;border-left: 1px solid #d6d6d6;color: #ce0704;margin-left: 5px;cursor: pointer;"
                        @click="del_title(item, index)">
                        删除
                    </div>
                </div>
            </div>

            <el-dialog title="修改编辑" :visible.sync="edit_title_show2" append-to-body custom-class="newdialog">
                <el-input type="textarea" v-model="edit_title_item.text" :rows="6" placeholder="请输入文案"></el-input>
                <div style="margin-top: 30px;display: flex;justify-content: end;">
                    <el-button type="success" style="width: 100px;" @click="edit_title_updata">保存</el-button>
                </div>
            </el-dialog>


        </el-dialog>

        <div class="el-image-viewer__wrapper" style="z-index: 2000;" v-if="lookvideo">
            <div class="el-image-viewer__mask" @click="lookvideo_close"></div>

            <span class="el-image-viewer__btn el-image-viewer__close">
                <i class="el-icon-close" @click="lookvideo_close"></i>
            </span>
            <!-- <span class="el-image-viewer__btn el-image-viewer__prev">
                <i class="el-icon-arrow-left"></i>
            </span>
            <span class="el-image-viewer__btn el-image-viewer__next">
                <i class="el-icon-arrow-right"></i>
            </span> -->

            <!-- <div class="el-image-viewer__btn el-image-viewer__actions">
                <div class="el-image-viewer__actions__inner"><i class="el-icon-zoom-out"></i><i
                        class="el-icon-zoom-in"></i><i class="el-image-viewer__actions__divider"></i><i
                        class="el-icon-full-screen"></i><i class="el-image-viewer__actions__divider"></i><i
                        class="el-icon-refresh-left"></i><i class="el-icon-refresh-right"></i></div>
            </div> -->
            <!---->
            <div class="el-image-viewer__canvas" style="display: flex;flex-direction: column;">
                <div ondragstart="return false;" class="el-image-viewer__img"
                    style="transform: scale(1) rotate(0deg); margin-left: 0px; margin-top: 0px; height: 650px; max-height: 80%; max-width: 80%;">
                    <video :src="lookvideo_src.video" style="max-height: 100%;max-width: 100%;width: auto;height: auto;"
                        controls="controls" controlslist="nodownload"></video>
                    <div style="color: #fff;text-align: center;">
                        <div
                            style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 350px;text-align: center;">
                            {{ lookvideo_src.name }} </div>
                        <el-button style="margin-top: 10px;font-size: 14px;" size="medium" icon="el-icon-download"
                            type="primary" @click="down_video(lookvideo_src)">下载</el-button>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import makevideo_view from "../User/Ku_makevideo.vue"
import upload_view from "../User/Ku_upload.vue"

export default {
    name: '',
    components: {
        makevideo_view,
        upload_view
    },
    // 定义属性
    data() {
        return {
            name_key: '',
            filterText: '',
            ku_files: [],
            ku_add: false,
            all_url: '',
            ku_add_music: true,
            cjwj: false,
            cjwj_from: {
                wjname: '',
            },
            rules: {
                wjname: [
                    { required: true, message: "名称不能为空", trigger: "blur" },

                    {
                        required: true,
                        pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9.·-]+$/,
                        message: "名称不支持特殊字符",
                        trigger: "blur",
                    },
                ],
            },
            search: '',
            jindu: false,
            total: 1,
            page: 1,
            props: {
                label: 'name',
                children: 'dir',
                isLeaf: 'leaf'
            },
            node_had: [],
            resolve_had: [],
            spk_files: [],
            spk_select: [],
            spk_parent_select: [],
            make_video: false,
            make_video_info: '',
            upload_video: false,

            defaultExpandIds: [],
            fast_get: 0,
            lookvideo: false,
            lookvideo_src: [],
            get_time: 0,
            chuli_pd: [],
            make_pd: [],
            surplus: 0,
            xm: 0,
            check_video: [],
            check_video_new: [],
            share_show: false,
            share_item: false,
            share_cover: [],
            share_cover_show: false,
            share_cover_page: 1,
            share_cover_total: 0,
            ku_type: [],
            ku_type_one: '',
            edit_title_show: false,
            edit_title_show2: false,
            edit_title_list: {
                bt: [],
                jb: []
            },
            edit_title_item: [],
            is_imgs: 0
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {
        filterText(val) {
            this.$refs.trees.filter(val);
        }
    },
    // 方法集合
    methods: {
        del_title(item, index) {
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$ajax.post('/qhy/haowu/haowu_text_del', item, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                    console.log(res.data)
                    if (res.data.status == 200) {
                        this.$toast.show("删除成功", 2000);
                        if (item.type == 1) {
                            this.edit_title_list.bt.splice(index, 1)
                        }
                        if (item.type == 2) {
                            this.edit_title_list.jb.splice(index, 1)
                        }
                    } else {
                        this.$msg.error(res.data.msg)
                    }

                })
            }).catch(() => {

            });

        },
        edit_title_updata() {
            console.log(this.edit_title_item)
            this.$ajax.post('/qhy/haowu/haowu_text_updata', this.edit_title_item, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    this.$toast.show("更新成功", 2000);
                    this.edit_title_show2 = false
                    if (!this.edit_title_item.id) {
                        if (this.edit_title_item.type == 1) {
                            this.edit_title_list.bt.push(res.data.data)
                        }
                        if (this.edit_title_item.type == 2) {
                            this.edit_title_list.jb.push(res.data.data)
                        }
                    }
                } else {
                    this.$msg.error(res.data.msg)
                }

            })
        },
        edit_title_fc() {
            this.edit_title_show = true
            // console.log(this.spk_select)
            this.$ajax.post('/qhy/haowu/haowu_text', this.spk_select, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    this.edit_title_list['jb'] = res.data.jb
                    this.edit_title_list['bt'] = res.data.bt
                } else {
                    this.$msg.error(res.data.msg)
                }

            })
        },
        ku_type_list() {

            this.$ajax.post('/qhy/spk/ku_type_list', { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    this.ku_type = res.data.data
                } else {
                    this.$msg.error(res.data.msg)
                }


            })
        },
        tree_edit(node) {
            console.log(node)
        },
        share_cover_set(item) {
            console.log(item)
            if (this.is_imgs == 1) {
                return
            }

            this.share_item.cover = item.image
            this.share_cover_show = false
        },
        share_set() {
            if (this.share_item.cover == '' || this.share_item.type == '') {
                this.$msg.error('未设置封面和类型')
                return
            }

            this.$ajax.post('/qhy/spk/share_set', this.share_item, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    this.share_show = false
                } else {
                    this.$msg.error(res.data.msg)
                }


            })
        },
        fy_share_cover_page(e) {
            if (this.is_imgs == 1) {
                this.imgs_list(e)
            } else {
                this.share_open(true, e)
            }

        },
        share_open(e, page = 1) {
            console.log(e)
            this.is_imgs = 0
            this.share_cover_page = page
            const loading = this.$loading(this.$loadinginfo);
            var data = this.share_item
            data['share'] = e
            this.$ajax.post('/qhy/spk/share_open?page=' + page, data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    this.share_cover = res.data.data.data
                    this.share_cover_total = res.data.data.total
                } else {
                    this.share_item.share = false
                    this.share_cover = []
                    this.$msg.error(res.data.msg)
                }
                loading.close();
            })
        },
        imgs_list(page = 1) {
            this.is_imgs = 1
            this.share_cover_page = page
            const loading = this.$loading(this.$loadinginfo);
            var data = this.spk_select
            data['id'] = this.spk_select.parent ? this.spk_select.parent : data.id
            this.$ajax.post('/qhy/haowu/haowu_imgs?page=' + page, data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    this.share_cover = res.data.data.data
                    this.share_cover_total = res.data.data.total
                } else {
                    this.share_cover = []
                    this.$msg.error(res.data.msg)
                }
                loading.close();
            })
        },
        del_img(item, index) {
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$ajax.post('/qhy/haowu/haowu_imgs_del', item, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                    console.log(res.data)
                    if (res.data.status == 200) {
                        this.$toast.show("删除成功", 2000);
                        this.share_cover.splice(index, 1)
                    } else {
                        this.$msg.error(res.data.msg)
                    }

                })
            }).catch(() => {

            });
        },
        tree_share(node) {
            console.log(node)
            if (node.data.share == 1) {
                node.data.share = true
            } else {
                node.data.share = false
            }
            this.share_item = node.data
            this.share_item.surplus = 1
            this.share_show = true
            this.share_cover = []
            this.share_open(node.data.share)
        },
        check_video_fc(value, id) {
            // console.log(e,t)
            // console.log(this.check_video)
            if (value) {
                for (let index = 0; index < this.spk_files.length; index++) {
                    if (this.spk_files[index]['id'] == id) {
                        this.check_video_new.push(this.spk_files[index])
                    }

                }
            } else {
                for (let index = 0; index < this.check_video_new.length; index++) {
                    if (this.check_video_new[index]['id'] == id) {
                        this.check_video_new.splice(index, 1)
                    }

                }
            }
            console.log(this.check_video_new)
        },
        ku_pay() {
            this.$parent.$parent.$parent.$parent.vip = true

            this.$nextTick(() => {
                // this.$parent.$parent.$parent.$children[2].$children[0].vip_list=[]
                this.$parent.$parent.$parent.$children[2].$children[0].buy_type = '视频仓库会员'
                this.$parent.$parent.$parent.$children[2].$children[0].vip_list_fc('视频仓库会员')
            })

            console.log()
        },
        tree_refresh(node) {
            //console.log(this.get_time)
            //console.log(Math.round(new Date().getTime() / 1000))
            if (this.get_time < Math.round(new Date().getTime() / 1000)) {
                this.$set(node, 'childNodes', []);
                this.tree_get_dir(node.data)
                this.get_time = Math.round(new Date().getTime() / 1000) + 1
            } else {
                this.$msg.error('请求过快，请稍等一下~')
            }

        },
        del_video(e, type = 0, node = '') {

            //  //console.log(e)
            this.$confirm('此操作将永久删除 "' + e.name + '" 文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const loading = this.$loading(this.$loadinginfo);
                var data = e
                this.$ajax.post('/qhy/spk/del_video', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                    console.log(res.data)
                    if (res.data.status == 200) {
                        //  //console.log(index)
                        if (type == 1) {
                            //删除文件夹

                            if (this.spk_select.id == node.data.id) {
                                this.name_key = ''
                                this.spk_select = []
                            }

                            const tid = node.data.id
                            const parent = node.parent;
                            const children = parent.data;
                            const index = children.findIndex(d => d.id === tid);
                            children.splice(index, 1);

                            node.parent.loaded = false
                            node.parent.expand()
                        } else {
                            this.tree_get_file(this.page)
                        }

                        this.$msg.success(res.data.msg)

                    } else {
                        this.$msg.error(res.data.msg)
                    }
                    loading.close();
                })

            }).catch(() => {

            });
        },
        down_video(item) {
            window.open(item.video, "_blank");
            // window.open(item.video + "&response-content-disposition=attachment;filename=" + item.name + "&response-Content-Type=application/octet-stream", "_blank");
        },
        lookvideo_fc(video) {
            this.lookvideo_src = video
            this.lookvideo = true
        },
        lookvideo_close() {
            this.lookvideo = false
            this.lookvideo_src = []
        },
        make_video_wc() {
            this.make_video = false
        },
        upload_video_wc() {
            this.upload_video = false
            this.jiance()
        },
        make_video_fc() {
            //  //console.log(this.spk_parent_select)
            this.make_video_info = this.spk_parent_select

            this.make_video = true

        },
        tree_del(node) {
            this.del_video(node.data, 1, node)

            //  //console.log(children)

        },
        fy_page(e) {
            this.tree_get_file(e)
            this.page = e
        },
        //优化之后的代码 不管有几级都可以适用
        filterNode(value, data, node) {
            if (!value) {
                return true;
            }
            let level = node.level;
            let _array = [];//这里使用数组存储 只是为了存储值。
            this.getReturnNode(node, _array, value);
            let result = false;
            _array.forEach((item) => {
                result = result || item;
            });
            return result;
        },
        getReturnNode(node, _array, value) {
            let isPass = node.data && node.data.name && node.data.name.indexOf(value) !== -1;
            isPass ? _array.push(isPass) : '';
            this.index++;
            //console.log(this.index)
            if (!isPass && node.level != 1 && node.parent) {
                this.getReturnNode(node.parent, _array, value);
            }
        },

        cjwj_fc(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ku_cjwj(this.cjwj_from.wjname)
                } else {
                    return false;
                }
            });
        },
        select_filename() {
            var xz = window.sessionStorage.getItem('select_filename')
            if (xz == '' || xz == undefined || xz == null) {
                this.name_key = this.ku_files[0].name

            } else {
                this.name_key = xz
            }
        },
        ku_list_files() {
            const loading = this.$loading(this.$loadinginfo);
            this.$ajax.post('/qhy/spk/ku_list_files', { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                //console.log(res.data)
                var jg = res.data
                if (res.data.status == 200) {
                    this.ku_files = jg.list
                    // this.select_filename()
                    //console.log(this.ku_files)

                } else {
                    // this.$msg.error(res.data.msg)
                    this.$alert(res.data.msg, '提示', {
                        confirmButtonText: '确定',
                        type: 'warning',
                        callback: action => {
                            this.$router.push('/user/index')
                        }
                    })

                }
                loading.close();
            })
        },
        // get_files(item, index) {

        //     const loading = this.$loading(this.$loadinginfo);
        //     var data = item
        //     data['page'] = 1
        //     this.$ajax.post('/qhy/spk/get_files', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
        //         if (res.data.status == 200) {
        //              //console.log(res.data)
        //             this.ku_files[index]['dir'] = res.data.dir
        //              //console.log(this.ku_files)
        //         } else {
        //             this.$msg.error(res.data.msg)
        //         }
        //         loading.close();
        //     })
        // },

        ku_cjwj(name) {
            //console.log(name)
            const loading = this.$loading(this.$loadinginfo);
            var data = { 'name': name }
            this.$ajax.post('/qhy/spk/cj_wjj', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                if (res.data.status == 200) {
                    this.cjwj = false
                    this.cjwj_from.wjname = ''
                    this.$msg.success(res.data.msg)
                    // this.ku_files.push({ 'id': res.data.msg, 'name': name, 'parent': 0 })
                    this.ku_files.unshift({ 'id': res.data.data.id, 'name': res.data.data.name, 'parent': 0, 'uid': res.data.data.uid })
                    this.treeclick(this.ku_files[0])
                } else {
                    this.$msg.error(res.data.msg)
                }
                loading.close();
            })

        },
        ku_tjlj() {

            if (this.all_url == '') {
                this.$msg.error('请填写视频链接')
                return
            }
            const loading = this.$loading(this.$loadinginfo);
            //  //console.log(this.spk_parent_select)
            var data = {
                'kuname': this.spk_parent_select.name,
                'all_url': this.all_url,
                'ku_ismusic': this.ku_add_music
            }
            this.$ajax.post('/qhy/spk/ku_url_chuli', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                //console.log(res.data)
                var jg = res.data
                if (res.data.status == 200) {
                    this.$msg.success(jg.msg)
                    this.ku_add = false
                    this.all_url = ''
                } else {
                    this.$msg.error(jg.msg)
                }
                loading.close();
            })

        },
        ku_add_close(done) {
            this.$confirm('确认关闭此窗口，关闭后填写数据将丢失')
                .then(_ => {
                    // 关闭方法-上方传的参数done
                    done();
                })
                .catch(_ => { });
        },
        tree_get_dir(item, resolve = '') {
            // const loading = this.$loading(this.$loadinginfo);
            var data = item
            this.$ajax.post('/qhy/spk/get_dir', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                //console.log(res.data)
                if (res.data.status == 200) {

                    // this.ku_files[index]['dir'] = res.data.dir
                    //  //console.log(this.ku_files)

                    if (resolve == '') {

                        this.$set(item, 'dir', [])
                        res.data.dir.forEach((one) => {
                            one['leaf'] = true
                            item.dir.push(one);
                        })
                        this.$msg.success('获取目录成功')
                    } else {
                        resolve(res.data.dir);
                    }

                } else {
                    this.$msg.error(res.data.msg)
                }
                // loading.close();
            })
        },
        loadNode(node, resolve, data) {
            // console.log('tree load', node)
            //console.log(node.level)

            if (this.defaultExpandIds != undefined && this.defaultExpandIds != null && this.defaultExpandIds != '' && this.fast_get == 0 && node.id != 0) {
                if (this.defaultExpandIds.length > 1) {//记录会话保存的选中
                    if (node.data.parent == this.defaultExpandIds[0]) {
                        this.treeclick(node.data, node)
                        this.$nextTick(() => {
                            this.$refs.trees.setCurrentKey(node.data.id); // 数据请求成功后，设置默认current  
                        });
                        this.fast_get = 1
                    }
                }
                try {
                    if (this.defaultExpandIds.length == 1) {
                        //console.log(node)
                        this.treeclick(node.data, node)
                        this.$nextTick(() => {
                            this.$refs.trees.setCurrentKey(node.data.id); // 数据请求成功后，设置默认current  
                        });
                        this.fast_get = 1
                    }
                } catch (e) {
                    //  //console.log(node)
                    //  //console.log('error',e)
                }

            }

            if (node.level === 0) {
                // this.node_had = node;
                // this.resolve_had = resolve;
                node.data = []
                var tree = []
                for (let index = 0; index < this.ku_files.length; index++) {
                    tree[index] = { name: this.ku_files[index]['name'] };
                }
                //console.log(tree)
                return resolve(tree);
            }

            if (node.level > 1) return resolve([]);
            if (node.level == 1) {
                this.tree_get_dir(node.data, resolve)
            }


        },

        tree_get_file(page, show = 0) {

            // const loading = this.$loading(this.$loadinginfo);

            var data = this.spk_select

            this.$ajax.post('/qhy/spk/get_files?page=' + page, data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                //console.log(res.data)
                if (res.data.status == 200) {
                    this.spk_files = res.data.list
                    this.total = res.data.total
                    // this.ku_files[index]['dir'] = res.data.dir
                    //  //console.log(this.ku_files)
                    if (show == 1) {
                        this.$msg.success(res.data.msg)
                    }

                } else {
                    this.$msg.error(res.data.msg)
                }
                // loading.close();
            })
        },
        treeclick(data, node = '') {
            console.log(this.spk_select)
            if (this.spk_select == data) {
                return
            }
            // this.tree_get_dir(node.data,resolve)
            // console.log(node.parent.data.name)
            if (node) {
                if (node.parent.data.name) {
                    this.name_key = node.parent.data.name + ' / ' + data.name
                    this.spk_parent_select = node.parent.data
                } else {
                    this.name_key = data.name + ' / 制作完成视频'
                    this.spk_parent_select = data
                    // this.loadNode(this.node_had,this.resolve_had)
                }
            } else {
                this.name_key = data.name + ' / 制作完成视频'
                this.spk_parent_select = data

                this.$nextTick(() => {
                    this.$refs.trees.setCurrentKey(data.id); // 数据请求成功后，设置默认current  
                });
            }


            this.page = 1
            this.spk_select = data
            this.tree_get_file(1)

            const zhankai = []
            if (node.level > 1) {
                zhankai.push(node.parent.data.id)
            }
            zhankai.push(Number(data.id))
            // console.log(zhankai)

            sessionStorage.setItem('defaultExpandIds', JSON.stringify(zhankai))
        },
        pd() {

            this.$ajax.get('qhy/spk/pd').then(res => {
                //console.log(res.data)
                var jg = res.data
                if (res.data.status == 200) {
                    this.chuli_pd = jg.chuli_pd
                    this.make_pd = jg.make_pd
                    this.xm = jg.xm
                    this.surplus = jg.surplus
                    // this.$msg.success(res.data.msg)
                } else {
                    // this.$router.push('/login')
                }

            })
        },
        jiance() {
            this.pd()
            this.dsq_time = this.common.time_10() + 1800//定时30分钟无操作清除定时器
            this.cleartime = 0
            this.timer = setInterval(() => {
                // console.log('计时器')
                if (this.cleartime == 1 || this.dsq_time < this.common.time_10()) {
                    clearInterval(this.timer);
                    this.timer = null;
                } else {
                    if (this.spk_select && this.name_key) {
                        this.tree_get_file(this.page)
                        // this.pd()
                    }

                }

            }, 5000)
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.ku_list_files()
        this.defaultExpandIds = JSON.parse(sessionStorage.getItem('defaultExpandIds'))
        this.jiance()
        this.ku_type_list()
        // console.log(this.$route.query.id)
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {


    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { this.cleartime = 1 }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.el-container {
    /* min-height: 80vh; */
    background-color: #fff;
    border-radius: 20px;
    overflow: auto;
    min-width: 800px;
}

.el-menu {
    border-right: none;
    height: 75vh;
}

.el-header {
    height: 70px;
    padding: 0;
}

.el-aside {
    border-right: 1px solid #ebeef5;

}

.el-main {
    /* padding: 0; */
    height: calc(100vh - 70px);
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: auto;

    /* min-height: 100px; */
}

.videotp {
    border: 1px solid #e8e8e8;
    border-radius: 10px;
    height: 250px;
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAHhJREFUGBmtUDEKwCAMNCYIDm6FPsXVp/kqZz/USdBFausQaK20S7OEy13uSMBau4qhtNZbjLHy2HsvJYOv/r+QXiLhyoFz7iGutRoiwpSSMMaInHO7bbHDubyUUpAxIrbZMdCdxpoJ2yjqmPozRyKE0Hocz5VS+wGb6CCmdrCpYQAAAABJRU5ErkJggg==);
}

/* .el-menu-item {
    height: 45px;
    line-height: 43px;
    font-weight: 600;
} */

/* 改变elementui 侧边栏移入颜色 */
.ku_bg>>>.el-menu-item:hover {
    background: #f3f5ff !important;
    /* color: #fff !important; */
}

.el-menu-item.is-active {
    background-color: #f3f5ff !important;
    color: #2885ff !important;
}

.el-aside::-webkit-scrollbar {
    display: none;
}

.sidear_container {
    max-height: 100%;
    overflow-y: auto;

    /* &::-webkit-scrollbar {
        // display: none;
    } */
}

::-webkit-scrollbar {
    width: 5px;
    height: 1px;

}

::-webkit-scrollbar-track-piece {
    background-color: rgb(232, 232, 232);
    border-radius: 6px;
}

::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    background-color: rgba(232, 232, 232, 0.7);
    border-radius: 6px;
}

::-webkit-scrollbar-thumb:horizontal {
    width: 5px;
    background-color: rgba(232, 232, 232, 0.7);
    border-radius: 6px;
}

.ku_bg>>>.el-tree-node__content {
    height: 45px;
}

.ku_bg>>>.tree_other {
    color: #fff;
}

.ku_bg>>>.tree_other {
    display: none;
}

.show-hide:hover .tree_other {
    display: inline-block;
}

.tree_button {
    padding-right: 0px;
    padding-top: 10px;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0px 1px !important;
}

.tree_button:hover {
    color: #2885ff;
}


@media only screen and (min-width: 1600px) {
    .el-col-xl-4 {
        width: 16.66667%;
    }
}

.box-card {
    padding: 0 !important;
}


.ku_bg>>>.el-checkbox__label {
    display: none !important;
}

.ku_bg>>>.el-checkbox__inner {
    border-radius: 10px;
    width: 20px;
    height: 20px;
}

.ku_bg>>>.el-checkbox__inner::after {
    top: 4px;
    left: 7px;
}

/*
.el-tree-node__content:hover .el-button{
     background-color: #333;  
    color:rgb(66, 66, 66);
    
}
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content:hover .el-button{
  background-color: #333 !important 
  color:rgb(66, 66, 66);
  
}
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content .el-button{
   background-color: #333 !important 
  color: #f0f7ff;
}*/
.tree_other {
    display: none;
}

.show-hide:hover .tree_other {
    display: flex;
}
</style>


// WEBPACK FOOTER //
// src/components/User/Ku.vue


// WEBPACK FOOTER //
// src/components/User/Ku.vue